import React, { useState, useEffect } from 'react';
import { Layout, Menu, Button } from 'antd';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  LeftOutlined,
  RightOutlined,
} from '@ant-design/icons';

import AddUser from '../AddUserForm';
import UsersTable from '../UserTable';
import AddRestaurantForm from '../AddRestaurant';
import RestaurantTable from '../RestaurantTable';
import MenuManagement from '../AddMenuItem';
import ViewMenu from '../ViewMenu';
import VendorManagement from '../VendorManagement';
import VendorTable from '../VendorTable';
import VendorProductPricing from '../VendorProductPricing';
import OrderManagement from '../OrderManagement';
import VendorSelection from '../VendorSelection';
import PurchaseOrder from '../PurchaseOrder';
import InventoryManagement from '../InventoryManagement';
import ReportPage from '../ReportPage';
import Production from '../Production';
import Customer from '../CustomerPricing';
import VendorInventory from '../VendorInventory';
import Attendance from '../WorkerAttendance';
import Billing from '../BillConfig';
import SC from '../SystemConfiguration';
import Home from '../AllHome';
import logo from './img/Logo.png';

const { Header, Content, Sider } = Layout;

const Dashboard = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(() => {
    const storedMenu = localStorage.getItem('selectedMenu');
    return storedMenu ? storedMenu : '1';
  });

  const [userRole, setUserRole] = useState('');

  useEffect(() => {
    const role = localStorage.getItem('role');
    setUserRole(role);
    localStorage.setItem('selectedMenu', selectedMenu);
  }, [selectedMenu]);

  const renderContent = () => {
    if (selectedMenu === '1' && userRole === 'admin') {
      return (
        <>
          <h2>Distributor Management</h2>
          <VendorManagement />
          <VendorTable />
        </>
      );
    }
    if (selectedMenu === '2' && userRole === 'admin') {
      return (
        <>
          <h2>User Management</h2>
          <AddUser />
          <UsersTable />
        </>
      );
    }
    if (selectedMenu === '3') {
      return (
        <>
          <h2>Brand Management</h2>
          <AddRestaurantForm />
          <RestaurantTable />
        </>
      );
    }
    if (selectedMenu === '4') {
      return (
        <>
          <h2>Menu Management</h2>
          <MenuManagement />
        </>
      );
    }
    if (selectedMenu === '5') return <ViewMenu />;
    if (selectedMenu === '6') return <Customer />;
    if (selectedMenu === '7') {
      return (
        <>
          <h2>Product Selling Pricing</h2>
          <VendorProductPricing />
        </>
      );
    }
    if (selectedMenu === '8' && userRole === 'admin') {
      return (
        <>
          <h2>Order Management</h2>
          <OrderManagement />
        </>
      );
    }
    if (selectedMenu === '9' && userRole === 'admin') {
      return (
        <>
          <h2>Vendor Selection</h2>
          <VendorSelection />
        </>
      );
    }
    if (selectedMenu === '10' && userRole === 'admin') {
      return (
        <>
          <h2>Purchase Order</h2>
          <PurchaseOrder />
        </>
      );
    }
    if (selectedMenu === '11') {
      return (
        <>
          <InventoryManagement />
        </>
      );
    }
    if (selectedMenu === '12') {
      return (
        <>
          <h2>Report</h2>
          <ReportPage />
        </>
      );
    }
    if (selectedMenu === '13') {
      return (
        <>
          <h2>Todays Production</h2>
          <Production />
        </>
      );
    }
     if (selectedMenu === '14') {
      return (
        <>
          <Home />
        </>
      );
    }
    if (selectedMenu === '15') {
      return (
        <>
          <Attendance />
        </>
      );
    }
    if (selectedMenu === '16') {
      return (
        <>
          <Billing />
        </>
      );
    }
    if (selectedMenu === '17') {
      return (
        <>
          <SC />
        </>
      );
    }
    if (selectedMenu === '9') return <VendorInventory />;
  };

  const handleMenuClick = ({ key }) => {
    setSelectedMenu(key);
    if (window.innerWidth < 768) {
      setCollapsed(true);
    }
  };

  const isMobile = window.innerWidth < 768;

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        breakpoint="md"
        collapsedWidth="0"
        width={220}
        collapsed={collapsed}
        trigger={null}
        style={{
          position: 'fixed',
          height: '100vh',
          zIndex: 1001,
          top: 0,
          left: 0,
        }}
      >
        <div
          style={{
            height: 80,
            padding: 10,
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <h1 style={{ color: 'white' }}>Menu</h1>
        </div>

        <Menu
          mode="inline"
          selectedKeys={[selectedMenu]}
          onClick={handleMenuClick}
          theme="dark"
          style={{ overflowY: 'auto', height: 'calc(100vh - 130px)' }}
        >
          {userRole === 'admin' && <Menu.Item key="1">Distributor Management</Menu.Item>}
          {userRole === 'admin' && <Menu.Item key="2">User Management</Menu.Item>}
          <Menu.Item key="3">Brand Management</Menu.Item>
          <Menu.Item key="4">Add Menu</Menu.Item>
          <Menu.Item key="5">Menu Management</Menu.Item>
          {userRole === 'vendor' && <Menu.Item key="6">Customer Pricing</Menu.Item>}
          <Menu.Item key="7">Product Selling Pricing</Menu.Item>
          {userRole === 'admin' && <Menu.Item key="8">Order Management</Menu.Item>}
          {userRole === 'vendor' && <Menu.Item key="9">Vendor Inventory</Menu.Item>}
          {userRole === 'admin' && <Menu.Item key="11">Inventory Management</Menu.Item>}
          {userRole === 'admin' && <Menu.Item key="13">Todays Production</Menu.Item>}
          {userRole === 'admin' && <Menu.Item key="14">Payment Report</Menu.Item>}
          {userRole === 'admin' && <Menu.Item key="15">Attendance Report</Menu.Item>}
          {userRole === 'vendor' && <Menu.Item key="16">Bill Configuration</Menu.Item>}
          {userRole === 'admin' && <Menu.Item key="17">System Configuration</Menu.Item>}
        </Menu>

        {/* Toggle Button - Always Visible on Mobile */}
<div
  style={{
    position: 'fixed',
    left: collapsed ? 0 : 220,
    top: 63,
    zIndex: 1100,
    padding: '0px',
    background: '#001529',
    borderRadius: '0 6px 6px 0',
    transition: 'left 0.3s ease',
  }}
>
  <Button
    type="text"
    icon={collapsed ? <RightOutlined /> : <LeftOutlined />}
    onClick={() => setCollapsed(!collapsed)}
    style={{ color: 'white' }}
  />
</div>

      </Sider>

      <Layout
        style={{
          marginLeft: !isMobile && !collapsed ? 220 : 0,
          transition: 'margin-left 0.2s',
        }}
      >
        <Header
          style={{
            backgroundColor: '#001529',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 16px',
            height: 64,
            flexWrap: 'wrap',
            zIndex: 1000,
            position: 'relative',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{ fontSize: '18px', color: '#fff' }}
            />
            <img src={logo} alt="Logo" style={{ height: 70, objectFit: 'contain' }} />
          </div>

          <div
            style={{
              fontWeight: 'bold',
              fontSize: '18px',
              color: '#fff',
              textAlign: 'center',
              flex: 1,
            }}
          >
            Admin Panel
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              danger
              onClick={() => {
                localStorage.clear();
                window.location.href = '/login';
              }}
              size="small"
            >
              Logout
            </Button>
          </div>
        </Header>

        <Content
          style={{
            padding: '16px',
            overflowY: 'auto',
            minHeight: 'calc(100vh - 64px)',
            background: '#fff',
          }}
        >
          {renderContent()}
        </Content>
      </Layout>
    </Layout>
  );
};

export default Dashboard;
